import Team4 from './Team4'
export default Team4
